import React, { useState } from 'react'
import { randomInt } from './constants'
//import MongoContext from './MongoContext'
import { mongodb, client, useAuth } from './Auth//use-auth'
import { useHistory, useParams } from 'react-router-dom'
import { makeStyles } from '@material-ui/core/styles'
import CssBaseline from '@material-ui/core/CssBaseline'
import Paper from '@material-ui/core/Paper'
import Button from '@material-ui/core/Button'
//import Link from '@material-ui/core/Link'
import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid'
import TextField from '@material-ui/core/TextField'

const useStyles = makeStyles(theme => ({
  layout: {
    width: 'auto',
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    [theme.breakpoints.up(600 + theme.spacing(2) * 2)]: {
      width: 600,
      marginLeft: 'auto',
      marginRight: 'auto'
    }
  },
  paper: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    padding: theme.spacing(2),
    [theme.breakpoints.up(600 + theme.spacing(3) * 2)]: {
      marginTop: theme.spacing(6),
      marginBottom: theme.spacing(6),
      padding: theme.spacing(3)
    }
  },
  buttons: {
    display: 'flex',
    justifyContent: 'flex-end'
  },
  button: {
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(1)
  }
}))

export default function InsertClient (props) {
  const classes = useStyles()
  const { auth, user } = useAuth()
  const { choice, clientId } = useParams()
  const history = useHistory()
  const [value, setValue] = useState({
    shortName: '',
    clientName: '',
    adress: '',
    contactPerson: '',
    phoneNr: '',
    email: '',
    memo: '',
    clientCars: []
  })

  const db = mongodb.db('silmandDB')

  React.useEffect(() => {
    const controlChoice = () => {
      if (user) {
        if (choice === 'change') {
          setValue(prevState => ({ ...prevState, id: props.location.query.id }))
          setValue(prevState => ({
            ...prevState,
            shortName: props.location.query.clientShortName
          }))
          setValue(prevState => ({
            ...prevState,
            clientName: props.location.query.clientName
          }))
          setValue(prevState => ({
            ...prevState,
            adress: props.location.query.adress
          }))
          setValue(prevState => ({
            ...prevState,
            contactPerson: props.location.query.contactPerson
          }))
          setValue(prevState => ({
            ...prevState,
            phoneNr: props.location.query.phoneNr
          }))
          setValue(prevState => ({
            ...prevState,
            email: props.location.query.email
          }))
          setValue(prevState => ({
            ...prevState,
            memo: props.location.query.memo
          }))

          // String(props.location.query.hidden) === 'true'
          //   ? setValue(prevState => ({ ...prevState, hidden: true }))
          //   : setValue(prevState => ({ ...prevState, hidden: false }))
        }
      } else {
        console.log('ei toimi', auth)
      }
    }
    controlChoice(choice)
  }, [])
  const handleChange = data => {
    switch (Object.keys(data)[0]) {
      case 'id':
        setValue(prevState => ({ ...prevState, id: data.id }))
        break
      case 'shortName':
        setValue(prevState => ({ ...prevState, shortName: data.shortName }))
        break
      case 'clientName':
        setValue(prevState => ({ ...prevState, clientName: data.clientName }))
        break
      case 'contactPerson':
        setValue(prevState => ({
          ...prevState,
          contactPerson: data.contactPerson
        }))
        break
      case 'adress':
        setValue(prevState => ({ ...prevState, adress: data.adress }))
        break
      case 'memo':
        setValue(prevState => ({ ...prevState, memo: data.memo }))
        break

      case 'email':
        setValue(prevState => ({ ...prevState, email: data.email }))
        break
      case 'phoneNr':
        setValue(prevState => ({ ...prevState, phoneNr: data.phoneNr }))
        break
      case 'hidden':
        String(data.hidden) === 'true'
          ? setValue(prevState => ({ ...prevState, hidden: false }))
          : setValue(prevState => ({ ...prevState, hidden: true }))
        break
      default:
        console.log('No entries from change field')
    }
  }
  const addClient = async event => {
    event.preventDefault()
    try {
      await db.collection('clients').insertOne({
        _id: parseInt(randomInt(0, 9)),
        owner_id: client.auth.user.id,
        clientShortName: value.shortName,
        clientName: value.clientName,
        adress: value.adress,
        contactPerson: value.contactPerson,
        phoneNr: value.phoneNr,
        email: value.email,
        memo: value.memo
      })
    } catch (e) {
      console.log('item find viga', e)
    } finally {
      props.history.go(-1)
    }
  }
  const changeClient = async event => {
    event.preventDefault()
    try {
      await db.collection('clients').updateOne(
        { _id: parseInt(clientId) },
        {
          $set: {
            clientShortName: value.shortName,
            clientName: value.clientName,
            adress: value.adress,
            contactPerson: value.contactPerson,
            phoneNr: value.phoneNr,
            email: value.email,
            memo: value.memo
          }
        }
      )
    } catch (e) {
      console.log('item find viga', e)
    } finally {
      history.go(-1)
    }
  }
  return (
    <React.Fragment>
      <CssBaseline />

      <main className={classes.layout}>
        <Paper className={classes.paper}>
          <Typography component='h6' variant='h6' align='center'>
            {choice === 'insert' ? ' Uus Klient' : 'Muuda kliendi andmeid'}
          </Typography>

          <Grid container spacing={3}>
            {choice === 'change' && (
              <Grid item xs={4} sm={2}>
                <TextField
                  variant='outlined'
                  id='id'
                  name='id'
                  label=' ID '
                  value={clientId}
                  InputProps={{
                    readOnly: true
                  }}
                />
              </Grid>
            )}

            <Grid item xs={12} sm={6}>
              <TextField
                variant='outlined'
                required
                id='clientName'
                name='clientName'
                label='Nimi'
                value={value.clientName}
                onChange={event =>
                  handleChange({ clientName: event.target.value })
                }
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                variant='outlined'
                required
                id='shortName'
                name='shortName'
                label='Lühinimi'
                value={value.shortName}
                onChange={event =>
                  handleChange({ shortName: event.target.value })
                }
                fullWidth
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                variant='outlined'
                required
                id='address'
                name='address'
                label='Aadress'
                value={value.adress}
                onChange={event => handleChange({ adress: event.target.value })}
                fullWidth
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                variant='outlined'
                id='contactPerson'
                name='contactPerson'
                label='Kontakt isik'
                value={value.contactPerson}
                onChange={event =>
                  handleChange({ contactPerson: event.target.value })
                }
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                variant='outlined'
                required
                id='phoneNr'
                name='phoneNr'
                label='phone'
                value={value.phoneNr}
                onChange={event =>
                  handleChange({ phoneNr: event.target.value })
                }
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                variant='outlined'
                id='email'
                name='email'
                label='email'
                value={value.email}
                onChange={event => handleChange({ email: event.target.value })}
                fullWidth
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                variant='outlined'
                id='memo'
                name='memo'
                label='Lisa Info'
                value={value.memo}
                onChange={event => handleChange({ memo: event.target.value })}
                fullWidth
              />
            </Grid>
          </Grid>

          <React.Fragment>
            <div className={classes.buttons}>
              <Button onClick={() => history.go(-1)} className={classes.button}>
                Tagasi
              </Button>
              {choice === 'insert' && (
                <Button
                  variant='contained'
                  color='primary'
                  onClick={addClient}
                  className={classes.button}
                >
                  Lisa
                </Button>
              )}
              {choice === 'change' && (
                <Button
                  variant='contained'
                  color='primary'
                  onClick={changeClient}
                  className={classes.button}
                >
                  Muuda
                </Button>
              )}
            </div>
          </React.Fragment>
        </Paper>
      </main>
    </React.Fragment>
  )
}
